import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Switch } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SwitchModifier } from '../../../_lib/Form2/elements/Switch/Switch';

export type AttributeGroupPropertiesDefaultViewData = {
  forFastSelection: boolean;
};

function AttributeGroupPropertiesDefaultViewContent({ forFastSelection }: AttributeGroupPropertiesDefaultViewData) {
  const { t } = useSonTranslation('AttributeGroups');

  return (
    <div className="attribute-group-properties">
      <Switch
        label={t('properties.fastSelection.label')}
        checked={forFastSelection}
        disabled
        modifierLabel={[SwitchModifier.POSITION_INHERIT]}
        param={{
          type: 'checkbox',
          name: 'forFastSelection',
          required: false,
          value: 'true',
          checked: forFastSelection,
        }}
      />
    </div>
  );
}

export const AttributeGroupPropertiesDefaultView = asView(AttributeGroupPropertiesDefaultViewContent);
export type AttributeGroupPropertiesDefaultView = ComponentProps<typeof AttributeGroupPropertiesDefaultView>;
